import { ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { CommandPalette } from "../CommandPalette";

export const LAST_ROUTE_KEY = "nav.lastRoute";

export function MainLayout({ children }: { children: ReactNode }) {
  const location = useLocation();

  // Remember the last meaningful route so "/" can land the user back there.
  useEffect(() => {
    if (location.pathname === "/" || location.pathname === "/login") return;
    try {
      localStorage.setItem(LAST_ROUTE_KEY, location.pathname + location.search);
    } catch {
      /* ignore storage failures */
    }
  }, [location.pathname, location.search]);

  return (
    <div className="flex h-screen bg-slate-50 font-sans overflow-hidden">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <TopBar />
        <main className="flex-1 overflow-y-auto p-5 min-w-0">
          {children}
        </main>
      </div>
      <CommandPalette />
    </div>
  );
}
